<div class="flex flex-col w-full h-full">

  <!-- Header -->
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ 'iconPickerTitle' | transloco }}</div>
    <div class="flex justify-end items-end ">
      <button mat-stroked-button (click)="save()" class="mr-5">
        {{ 'save' | transloco }}
      </button>
      <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
        <mat-icon class="text-current" svgIcon="mat_outline:close"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Loader -->
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <!-- filters -->
  <div class="flex flex-0 flex-col sm:flex-row gap-6 px-6 py-4 bg-gray-50 dark:bg-black dark:bg-opacity-10">
    <mat-form-field class="flex-auto">
      <mat-label>{{ 'iconPickerNameSearch' | transloco}}</mat-label>
      <input matInput autocomplete="off" (input)="filterIcons($event)">
    </mat-form-field>
    <mat-form-field class="flex-auto">
      <mat-label>{{ 'iconPickerSpaceSearch' | transloco}}</mat-label>
      <mat-select [formControl]="familyFilterControl">
        <mat-option value="">{{ 'all' | transloco}}</mat-option>
        @for (nameSpace of nameSpaces$; track nameSpace) {
          <mat-option [value]="nameSpace.name">
            {{ nameSpace.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="min-w-40">
      <mat-label>{{ 'iconPickerSize' | transloco}}</mat-label>
      <mat-select [(ngModel)]="iconSize">
        <mat-option value="icon-size-4">16</mat-option>
        <mat-option value="icon-size-5">20</mat-option>
        <mat-option value="icon-size-6">24</mat-option>
        <mat-option value="icon-size-8">32</mat-option>
        <mat-option value="icon-size-10">40</mat-option>
        <mat-option value="icon-size-12">48</mat-option>
        <mat-option value="icon-size-16">64</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Content -->
  <div #iconsWrapper class="flex flex-row flex-wrap flex-auto justify-center px-6 py-2 sm:px-8 sm:py-4" fuseScrollbar>
    @if ((filteredIcons$ | async); as icons) {
      @for (icon of icons; track icon) {
        @for (item of icon.list; track item) {
          <div class="flex flex-col items-center justify-center m-4 p-4 min-w-36 max-w-36 min-h-30 max-h-30 rounded border-2 cursor-pointer bg-card"
            [class.border-primary]="selectedIcon[1] === item && selectedIcon[0] === icon.namespace"
            (click)="selectIcon(icon.namespace, item)">
            <div class="flex items-center justify-center mb-3">
              <mat-icon [ngClass]="iconSize" [svgIcon]="icon.namespace + ':' + item"></mat-icon>
            </div>
            <div class="text-sm text-center break-all text-secondary">{{ item }}</div>
          </div>
        }
      }
    }
  </div>
</div>